// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-reply-message-confirm #text{white-space:pre-wrap;word-wrap:break-word}#other-user-reply-message-confirm .preview-image,#other-user-reply-message-confirm .preview-video{padding:.25rem;border:1px solid #9b9b9b;border-radius:.25rem}#other-user-reply-message-confirm .back-btn,#other-user-reply-message-confirm .send-btn{min-width:84px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
